import {
	AnonymousRoutes,
	AuthedRoutes,
	AdminRoutes,
	Logout,
	Login,
	Dashboard,
	MyGroups,
	MyLocations,
	Group,
	SessionDashboard,
	EditAction,
	EditEquipment,
	EditMagicalAttribute,
	EditMonster,
	EditLocation,
	DMTools,
	MonsterList,
	ActionList,
	EquipmentList,
	MagicalAttributeList,
} from "pages";

const routes = [
	{
		path: "logout",
		element: <Logout />,
	},

	{
		path: "",
		element: <AnonymousRoutes />,
		children: [
			{
				path: "login",
				element: <Login />,
			},
		],
	},

	{
		path: "",
		element: <AuthedRoutes />,
		children: [
			{
				index: true,
				element: <Dashboard />,
			},

			{
				path: "my_groups",
				element: <MyGroups />,
			},
			{
				path: "group/:id",
				element: <Group />,
			},
			{
				path: "session/:id",
				element: <SessionDashboard />,
			},
			{
				path: "my_locations",
				element: <MyLocations />,
			},
		],
	},

	{
		path: "dm_tools",
		element: <AdminRoutes />,
		children: [
			{
				index: true,
				element: <DMTools />,
			},
			{
				path: "monster_list",
				element: <MonsterList />,
			},
			{
				path: "action_list",
				element: <ActionList all={true} />,
			},
			{
				path: "equipment_list",
				element: <EquipmentList />,
			},
			{
				path: "magical_attribute_list",
				element: <MagicalAttributeList />,
			},
		],
	},

	{
		path: "",
		element: <AdminRoutes />,
		children: [
			//Editing
			{
				path: "edit_action",
				element: <EditAction />,
			},
			{
				path: "edit_equipment",
				element: <EditEquipment />,
			},
			{
				path: "edit_magical_attribute",
				element: <EditMagicalAttribute />,
			},
			{
				path: "edit_monster",
				element: <EditMonster />,
			},
			{
				path: "edit_location",
				element: <EditLocation />,
			},
			{
				path: "edit_action/:id",
				element: <EditAction />,
			},
			{
				path: "edit_equipment/:id",
				element: <EditEquipment />,
			},
			{
				path: "edit_magical_attribute/:id",
				element: <EditMagicalAttribute />,
			},
			{
				path: "edit_monster/:id",
				element: <EditMonster />,
			},
			{
				path: "edit_location/:id",
				element: <EditLocation />,
			},
		],
	},
];

export default routes;
